import api from '@motionelements/core/src/api/base-api-v2';

export const getProfilePage = async () => {
  const url = '/v2/artist/pages/profile';
  return api.get(url);
};

export const updateProfilePage = async (payload) => {
  const url = '/v2/artist/pages/profile';
  return api.request('patch', url, {
    data: payload,
  });
};

export const updateProfileImage = async ({ type, blob }) => {
  const url = '/v2/artist/pages/image';
  return api.request('put', url, {
    data: {
      type: type,
      blob: blob,
    },
  });
};

export const updateAvatar = async ({ blob }) => {
  const url = '/v2/account/avatar';
  return api.request('put', url, {
    data: {
      blob: blob,
    },
  });
};

export const getFavourites = async () => {
  const url = '/v2/favorites';
  return api.get(url);
};
